import React from 'react';

import { ThemeLogoIcon } from '../theme-logo-icon/ThemeLogoIcon';
import * as S from './ThemeHeader.styles';

interface ThemeHeaderProps {
  themeName: string;
  logo_url?: string;
  isCondensed?: boolean;
}

export const ThemeHeader = ({
  themeName,
  logo_url,
  isCondensed = false,
}: ThemeHeaderProps) => {
  return (
    <S.FlexRowWrapper>
      <S.LogoAndTitleWrapper $isCondensed={isCondensed}>
        <ThemeLogoIcon
          logo_url={logo_url}
          name={themeName}
          key={themeName}
          isCondensed={isCondensed}
        />
        <S.TitleText $isCondensed={isCondensed}>{themeName}</S.TitleText>
      </S.LogoAndTitleWrapper>
    </S.FlexRowWrapper>
  );
};
